(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-flavor-media-section]';
  var MEDIA_SELECTOR = '[data-media-flavor]';
  var SHARED_FLAVOR = 'all';

  function normalizeHandle(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[’']/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function parseFlavorAltText(altText) {
    var originalAlt = String(altText || '').trim();
    var parts = originalAlt.split('|');
    var groupLabel = String(parts[0] || '').trim();
    var flavorMatch = groupLabel.match(/^flavor\s*:\s*(.+)$/i);

    if (!flavorMatch) {
      return {
        flavor: SHARED_FLAVOR,
        cleanAlt: originalAlt,
        tagged: false
      };
    }

    return {
      flavor: normalizeHandle(flavorMatch[1]) || SHARED_FLAVOR,
      cleanAlt: parts.length > 1 ? parts.slice(1).join('|').trim() : '',
      tagged: true
    };
  }

  function parseJSON(element) {
    if (!element) return null;

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.warn('Flavor media gallery: invalid product JSON.', error);
      return null;
    }
  }

  function normalizeMediaId(mediaId) {
    var parts = String(mediaId || '').split('-');
    return parts[parts.length - 1] || '';
  }

  function mediaMatchesFlavor(element, flavor) {
    if (!flavor) return true;

    var mediaFlavor = normalizeHandle(element.getAttribute('data-media-flavor')) || SHARED_FLAVOR;
    return mediaFlavor === SHARED_FLAVOR || mediaFlavor === flavor;
  }

  function FlavorMediaGallery(section) {
    this.section = section;
    this.sectionId = section.getAttribute('data-flavor-media-section') || '';
    this.config = parseJSON(section.querySelector('[data-flavor-media-product-json]'));
    this.flavorOptionIndex = this.getFlavorOptionIndex();
    this.activeFlavor = '';
    this.applyTimer = null;
    this.slickWaitTimer = null;
    this.slickWaitAttempts = 0;
    this.boundHandleChange = this.handleChange.bind(this);
    this.boundApply = this.apply.bind(this);

    if (!this.config || this.flavorOptionIndex === -1) return;

    this.prepareMediaItems();
    if (!this.section.querySelector(MEDIA_SELECTOR + ':not([data-media-flavor="all"])')) return;

    this.bindEvents();
    this.apply();
    this.waitForSlick();
  }

  FlavorMediaGallery.prototype.prepareMediaItems = function () {
    var galleryItems = this.section.querySelectorAll(
      '.product-media-gallery .product__media-item, ' +
      '.product__gallery_old .product__media-item'
    );

    galleryItems.forEach(function (item) {
      var image = item.querySelector('img[alt]');
      var parsedAlt = parseFlavorAltText(image ? image.getAttribute('alt') : '');

      item.setAttribute('data-media-flavor', parsedAlt.flavor);

      if (image && parsedAlt.tagged) {
        image.setAttribute('alt', parsedAlt.cleanAlt);
      }
    });

    this.section.querySelectorAll('.product-media-modal__content img[alt]').forEach(function (image) {
      var parsedAlt = parseFlavorAltText(image.getAttribute('alt'));

      if (parsedAlt.tagged) {
        image.setAttribute('alt', parsedAlt.cleanAlt);
      }
    });
  };

  FlavorMediaGallery.prototype.getFlavorOptionIndex = function () {
    if (!this.config || !Array.isArray(this.config.options)) return -1;

    return this.config.options.findIndex(function (optionName) {
      return String(optionName || '').trim().toLowerCase().indexOf('flavor') !== -1;
    });
  };

  FlavorMediaGallery.prototype.getProductForm = function () {
    if (!this.sectionId) return null;
    return document.getElementById('product-form-' + this.sectionId);
  };

  FlavorMediaGallery.prototype.getVariantPicker = function () {
    return this.section.querySelector(
      'variant-radios[data-section="' + this.sectionId + '"], ' +
      'variant-selects[data-section="' + this.sectionId + '"]'
    );
  };

  FlavorMediaGallery.prototype.getSelectedOptions = function () {
    var picker = this.getVariantPicker();
    if (!picker) return [];

    var fieldsets = Array.prototype.slice.call(picker.querySelectorAll('fieldset'));
    if (fieldsets.length) {
      return fieldsets.map(function (fieldset) {
        var checkedInput = fieldset.querySelector('input:checked');
        return checkedInput ? checkedInput.value : '';
      });
    }

    return Array.prototype.slice.call(picker.querySelectorAll('select')).map(function (select) {
      return select.value;
    });
  };

  FlavorMediaGallery.prototype.getCurrentVariant = function () {
    var variants = this.config && Array.isArray(this.config.variants) ? this.config.variants : [];
    var selectedOptions = this.getSelectedOptions();

    if (selectedOptions.length) {
      var optionMatchedVariant = variants.find(function (variant) {
        if (!Array.isArray(variant.options) || variant.options.length !== selectedOptions.length) return false;

        return variant.options.every(function (optionValue, optionIndex) {
          return String(optionValue) === String(selectedOptions[optionIndex]);
        });
      });

      if (optionMatchedVariant) return optionMatchedVariant;
    }

    var productForm = this.getProductForm();
    var variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
    var currentVariantId = variantInput ? Number(variantInput.value) : Number(this.config.selectedVariantId);

    return variants.find(function (variant) {
      return Number(variant.id) === currentVariantId;
    }) || null;
  };

  FlavorMediaGallery.prototype.getCurrentFlavor = function () {
    var variant = this.getCurrentVariant();
    if (!variant || !Array.isArray(variant.options)) return '';

    return normalizeHandle(variant.options[this.flavorOptionIndex]);
  };

  FlavorMediaGallery.prototype.hasDedicatedMedia = function (flavor) {
    if (!flavor) return false;

    return Array.prototype.some.call(this.section.querySelectorAll(MEDIA_SELECTOR), function (item) {
      return normalizeHandle(item.getAttribute('data-media-flavor')) === flavor;
    });
  };

  FlavorMediaGallery.prototype.setElementVisibility = function (element, isVisible) {
    element.hidden = !isVisible;
    element.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
  };

  FlavorMediaGallery.prototype.filterRegularItems = function (flavor) {
    var self = this;

    this.section.querySelectorAll(
      '.product-gallery-single:not(.slick-initialized) ' + MEDIA_SELECTOR + ', ' +
      '.product-gallery-thumbnails:not(.slick-initialized) ' + MEDIA_SELECTOR
    ).forEach(function (item) {
      self.setElementVisibility(item, mediaMatchesFlavor(item, flavor));
    });
  };

  FlavorMediaGallery.prototype.filterSlickSlider = function (slider, flavor) {
    if (!window.jQuery || !window.jQuery.fn || typeof window.jQuery.fn.slick !== 'function') return false;

    var $slider = window.jQuery(slider);
    if (!$slider.hasClass('slick-initialized')) return false;

    try {
      $slider.slick('slickUnfilter');

      $slider.find(MEDIA_SELECTOR).each(function () {
        this.hidden = false;
        this.setAttribute('aria-hidden', 'false');
      });

      $slider.slick('slickFilter', function () {
        return mediaMatchesFlavor(this, flavor);
      });

      $slider.slick('setPosition');
      $slider.slick('slickGoTo', 0, true);
      return true;
    } catch (error) {
      console.warn('Flavor media gallery: unable to refresh Slick.', error);
      return false;
    }
  };

  FlavorMediaGallery.prototype.filterDesktopGallery = function (flavor) {
    var mainSlider = this.section.querySelector('.product-gallery-single');
    var thumbnailSlider = this.section.querySelector('.product-gallery-thumbnails');

    this.filterRegularItems(flavor);

    if (thumbnailSlider) this.filterSlickSlider(thumbnailSlider, flavor);
    if (mainSlider) this.filterSlickSlider(mainSlider, flavor);
  };

  FlavorMediaGallery.prototype.filterMobileGallery = function (flavor) {
    var self = this;
    var mobileGallery = this.section.querySelector('.product__gallery_old');
    if (!mobileGallery) return;

    var mediaList = mobileGallery.querySelector('.product__media-list');
    if (!mediaList) return;

    var items = Array.prototype.slice.call(mediaList.querySelectorAll(MEDIA_SELECTOR));
    var visibleItems = [];

    items.forEach(function (item) {
      var isVisible = mediaMatchesFlavor(item, flavor);
      self.setElementVisibility(item, isVisible);

      if (isVisible) visibleItems.push(item);
    });

    mediaList.scrollLeft = 0;

    var currentCounter = mobileGallery.querySelector('.slider-counter--current');
    var totalCounter = mobileGallery.querySelector('.slider-counter--total');
    var sliderButtons = mobileGallery.querySelector('.slider-buttons');

    if (currentCounter) currentCounter.textContent = visibleItems.length ? '1' : '0';
    if (totalCounter) totalCounter.textContent = String(visibleItems.length);
    if (sliderButtons) sliderButtons.classList.toggle('small-hide', visibleItems.length < 2);

    if (typeof mobileGallery.initPages === 'function') {
      requestAnimationFrame(function () {
        mobileGallery.initPages();
      });
    }
  };

  FlavorMediaGallery.prototype.filterModal = function (flavor) {
    var mediaFlavorById = {};

    this.section.querySelectorAll('.product-media-gallery ' + MEDIA_SELECTOR).forEach(function (item) {
      var mediaId = normalizeMediaId(item.getAttribute('data-media-id'));
      if (!mediaId || mediaFlavorById[mediaId]) return;
      mediaFlavorById[mediaId] = item.getAttribute('data-media-flavor') || SHARED_FLAVOR;
    });

    this.section.querySelectorAll('.product-media-modal__content [data-media-id]').forEach(function (modalItem) {
      var mediaId = normalizeMediaId(modalItem.getAttribute('data-media-id'));
      var mediaFlavor = normalizeHandle(mediaFlavorById[mediaId]) || SHARED_FLAVOR;
      var isVisible = !flavor || mediaFlavor === SHARED_FLAVOR || mediaFlavor === flavor;

      modalItem.hidden = !isVisible;
      modalItem.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    });
  };

  FlavorMediaGallery.prototype.apply = function () {
    var flavor = this.getCurrentFlavor();
    if (!flavor) return;

    var filterFlavor = this.hasDedicatedMedia(flavor) ? flavor : '';

    this.activeFlavor = flavor;
    this.section.setAttribute('data-active-media-flavor', flavor);
    this.section.removeAttribute('data-active-media-purchase');

    this.filterDesktopGallery(filterFlavor);
    this.filterMobileGallery(filterFlavor);
    this.filterModal(filterFlavor);
  };

  FlavorMediaGallery.prototype.scheduleApply = function () {
    var self = this;

    window.clearTimeout(this.applyTimer);
    this.applyTimer = window.setTimeout(function () {
      self.apply();
    }, 50);
  };

  FlavorMediaGallery.prototype.handleChange = function (event) {
    var picker = this.getVariantPicker();
    var productForm = this.getProductForm();
    var target = event.target;

    if (!target) return;
    if (picker && picker.contains(target)) this.scheduleApply();
    if (productForm && productForm.contains(target) && target.name === 'id') this.scheduleApply();
  };

  FlavorMediaGallery.prototype.bindEvents = function () {
    this.section.addEventListener('change', this.boundHandleChange);
    this.section.addEventListener('variant:change', this.boundApply);
    this.section.addEventListener('product:variant-change', this.boundApply);
  };

  FlavorMediaGallery.prototype.waitForSlick = function () {
    var self = this;

    window.clearTimeout(this.slickWaitTimer);

    function checkSlick() {
      var mainSlider = self.section.querySelector('.product-gallery-single');
      var thumbnailSlider = self.section.querySelector('.product-gallery-thumbnails');
      var mainReady = !mainSlider || mainSlider.classList.contains('slick-initialized');
      var thumbnailsReady = !thumbnailSlider || thumbnailSlider.classList.contains('slick-initialized');

      if (mainReady && thumbnailsReady) {
        self.apply();
        return;
      }

      self.slickWaitAttempts += 1;

      if (self.slickWaitAttempts >= 40) return;

      self.slickWaitTimer = window.setTimeout(checkSlick, 100);
    }

    checkSlick();
  };

  function initializeFlavorMediaGalleries(scope) {
    var root = scope || document;
    var sections = [];

    if (root.matches && root.matches(SECTION_SELECTOR)) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections = sections.concat(Array.prototype.slice.call(root.querySelectorAll(SECTION_SELECTOR)));
    }

    sections.forEach(function (section) {
      if (section.dataset.flavorMediaInitialized === 'true') return;

      section.dataset.flavorMediaInitialized = 'true';
      new FlavorMediaGallery(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeFlavorMediaGalleries(document);
    });
  } else {
    initializeFlavorMediaGalleries(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeFlavorMediaGalleries(event.target);
  });
})();
